/**
 * Common data used across the application
 */

/**
 * Common country data with flags
 */
export const commonCountries = [
  // United Kingdom
  { id: 0, name: 'United Kingdom', flag: '🇬🇧' },
  
  // African Countries
  { id: 0, name: 'Algeria', flag: '🇩🇿' },
  { id: 0, name: 'Angola', flag: '🇦🇴' },
  { id: 0, name: 'Benin', flag: '🇧🇯' },
  { id: 0, name: 'Botswana', flag: '🇧🇼' },
  { id: 0, name: 'Burkina Faso', flag: '🇧🇫' },
  { id: 0, name: 'Burundi', flag: '🇧🇮' },
  { id: 0, name: 'Cabo Verde', flag: '🇨🇻' },
  { id: 0, name: 'Cameroon', flag: '🇨🇲' },
  { id: 0, name: 'Central African Republic', flag: '🇨🇫' },
  { id: 0, name: 'Chad', flag: '🇹🇩' },
  { id: 0, name: 'Comoros', flag: '🇰🇲' },
  { id: 0, name: 'Congo, Democratic Republic of the', flag: '🇨🇩' },
  { id: 0, name: 'Congo, Republic of the', flag: '🇨🇬' },
  { id: 0, name: 'Côte d\'Ivoire', flag: '🇨🇮' },
  { id: 0, name: 'Djibouti', flag: '🇩🇯' },
  { id: 0, name: 'Egypt', flag: '🇪🇬' },
  { id: 0, name: 'Equatorial Guinea', flag: '🇬🇶' },
  { id: 0, name: 'Eritrea', flag: '🇪🇷' },
  { id: 0, name: 'Eswatini', flag: '🇸🇿' },
  { id: 0, name: 'Ethiopia', flag: '🇪🇹' },
  { id: 0, name: 'Gabon', flag: '🇬🇦' },
  { id: 0, name: 'Gambia', flag: '🇬🇲' },
  { id: 0, name: 'Ghana', flag: '🇬🇭' },
  { id: 0, name: 'Guinea', flag: '🇬🇳' },
  { id: 0, name: 'Guinea-Bissau', flag: '🇬🇼' },
  { id: 0, name: 'Kenya', flag: '🇰🇪' },
  { id: 0, name: 'Lesotho', flag: '🇱🇸' },
  { id: 0, name: 'Liberia', flag: '🇱🇷' },
  { id: 0, name: 'Libya', flag: '🇱🇾' },
  { id: 0, name: 'Madagascar', flag: '🇲🇬' },
  { id: 0, name: 'Malawi', flag: '🇲🇼' },
  { id: 0, name: 'Mali', flag: '🇲🇱' },
  { id: 0, name: 'Mauritania', flag: '🇲🇷' },
  { id: 0, name: 'Mauritius', flag: '🇲🇺' },
  { id: 0, name: 'Morocco', flag: '🇲🇦' },
  { id: 0, name: 'Mozambique', flag: '🇲🇿' },
  { id: 0, name: 'Namibia', flag: '🇳🇦' },
  { id: 0, name: 'Niger', flag: '🇳🇪' },
  { id: 0, name: 'Nigeria', flag: '🇳🇬' },
  { id: 0, name: 'Rwanda', flag: '🇷🇼' },
  { id: 0, name: 'São Tomé and Príncipe', flag: '🇸🇹' },
  { id: 0, name: 'Senegal', flag: '🇸🇳' },
  { id: 0, name: 'Seychelles', flag: '🇸🇨' },
  { id: 0, name: 'Sierra Leone', flag: '🇸🇱' },
  { id: 0, name: 'Somalia', flag: '🇸🇴' },
  { id: 0, name: 'South Africa', flag: '🇿🇦' },
  { id: 0, name: 'South Sudan', flag: '🇸🇸' },
  { id: 0, name: 'Sudan', flag: '🇸🇩' },
  { id: 0, name: 'Tanzania', flag: '🇹🇿' },
  { id: 0, name: 'Togo', flag: '🇹🇬' },
  { id: 0, name: 'Tunisia', flag: '🇹🇳' },
  { id: 0, name: 'Uganda', flag: '🇺🇬' },
  { id: 0, name: 'Zambia', flag: '🇿🇲' },
  { id: 0, name: 'Zimbabwe', flag: '🇿🇼' },
];

// African Currencies plus GBP
export const currencies = [
  { code: 'GBP', name: 'British Pound', symbol: '£', flag: '🇬🇧' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R', flag: '🇿🇦' },
  { code: 'NGN', name: 'Nigerian Naira', symbol: '₦', flag: '🇳🇬' },
  { code: 'GHS', name: 'Ghanaian Cedi', symbol: '₵', flag: '🇬🇭' },
  { code: 'KES', name: 'Kenyan Shilling', symbol: 'Ksh', flag: '🇰🇪' },
  { code: 'EGP', name: 'Egyptian Pound', symbol: 'E£', flag: '🇪🇬' },
  { code: 'ETB', name: 'Ethiopian Birr', symbol: 'Br', flag: '🇪🇹' },
  { code: 'MAD', name: 'Moroccan Dirham', symbol: 'DH', flag: '🇲🇦' },
  { code: 'TZS', name: 'Tanzanian Shilling', symbol: 'TSh', flag: '🇹🇿' },
  { code: 'XOF', name: 'West African CFA franc', symbol: 'CFA', flag: '🇸🇳' },
  { code: 'XAF', name: 'Central African CFA franc', symbol: 'FCFA', flag: '🇨🇲' },
  { code: 'UGX', name: 'Ugandan Shilling', symbol: 'USh', flag: '🇺🇬' },
  { code: 'ZMW', name: 'Zambian Kwacha', symbol: 'ZK', flag: '🇿🇲' },
  { code: 'RWF', name: 'Rwandan Franc', symbol: 'RF', flag: '🇷🇼' },
  { code: 'MWK', name: 'Malawian Kwacha', symbol: 'MK', flag: '🇲🇼' },
  { code: 'NAD', name: 'Namibian Dollar', symbol: 'N$', flag: '🇳🇦' },
  { code: 'BWP', name: 'Botswana Pula', symbol: 'P', flag: '🇧🇼' },
  { code: 'MUR', name: 'Mauritian Rupee', symbol: '₨', flag: '🇲🇺' },
  { code: 'USD', name: 'US Dollar', symbol: '$', flag: '🇺🇸' },
  { code: 'EUR', name: 'Euro', symbol: '€', flag: '🇪🇺' },
]; 